import PureCounter from "@srexi/purecounterjs/js/purecounter";

export function initCounter() {
    // Initialisierung des PureCounter
    const pureCounter = new PureCounter({
        // Default-Optionen
        once: true,  // Nur einmal ausführen
        legacy: true // Unterstützung für ältere Browser
    });
}